module.exports = __webpack_public_path__ + "static/media/solution.ec97af3c.svg";